import { trackSuccessSendCustomAction } from '../actions/userCard/tracking';
import { fetchChatsCustomAction, TChatsCustomActionResponse } from '../repositories/chats/v1/chats/custom-action';
import { currentChatOpponentIdSelector, currentOpenChatSelector, customActionsSelector } from '../selectors';
import { showAlert } from '../slices/alertSlice';
import { EAlert } from '../types/alert';
import { TAction } from '../types/customActions';
import { EExceptionDomain } from '../types/exceptionDomains';
import { TThunkAction } from '../types/redux/thunk';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

type TSendCustomActionParams = {
  action: TAction;
  chatId: string;
  companionId: number | undefined;
};

const DEFAULT_ERROR_MESSAGE = 'Ошибка при отправке сообщения о действии с чатом';

export const sendCustomActions =
  ({ action, chatId, companionId }: TSendCustomActionParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const state = getState();

    const customActions = customActionsSelector(state);
    const currentChat = currentOpenChatSelector(state);
    const opponentId = currentChatOpponentIdSelector(state);

    const button = customActions ? customActions.find(button => button.action === action) : undefined;

    try {
      const { response, statusCode }: TChatsCustomActionResponse = await fetchChatsCustomAction({
        httpApi,
        parameters: {
          action,
          chatId,
        },
        config: {
          requestConfig: {
            withCredentials: true,
          },
        },
      });

      if (statusCode !== 200) {
        throw getResponseError({
          domain: EExceptionDomain.Chat,
          response,
          defaultMessage: DEFAULT_ERROR_MESSAGE,
          statusCode,
        });
      }

      trackSuccessSendCustomAction(currentChat, action, companionId, opponentId);

      if (button?.successDescription) {
        dispatch(showAlert({ message: button.successDescription, type: EAlert.Info }));
      }
    } catch (error) {
      const exception = getGenericLikeError({
        error,
        domain: EExceptionDomain.Chat,
        message: DEFAULT_ERROR_MESSAGE,
      });

      logger.error(exception, {
        microserviceName: 'chats',
        pathApi: '/v1/chats/custom-action/',
        parameters: JSON.stringify({ action, chatId }),
      });

      dispatch(showAlert({ message: 'Сервисная ошибка. Повторите попытку' }));
    }
  };
